<div class="credits-modal-wrapper">
    <div class="container-fluid" style="padding: 0; padding-top: 20px; padding-bottom: 8px;">
        <div class="row" style="margin: 0;">
            <div class="col-md-12" style="padding: 8px 0 16px 0;">
                <img src="assets/images/credits.svg" alt="credits-image">
            </div>
        </div>
        <div class="row" style="margin: 0;">
            <div class="col-md-12 title" style="padding-top: 8px;">
                {{'generic_partner_portal' | translate}}
            </div>
            <div class="col-md-12 version">
                {{'generic_version' | translate}} {{ version }} {{'generic_powered_by_small' | translate}}
                <div class="credits-powered-wrapper">
                    <a target="_blank" rel="noopener noreferrer" href="https://transporeon.com/" class="rotating-icon">
                        <img src="/assets/images/tp-logo.svg" style="height: 36px;" alt="powered-logo">
                    </a>
                </div>
                <!-- <img src="assets/images/logo-powered-black.svg" style="height: 32px;" alt="powered-image"> -->
            </div>
            <div class="col-md-12" style="padding: 0 0 16px 0;">
                <a target="_blank" rel="noopener noreferrer" [href]="privacyLink">{{'generic_privacy_policy' |
                    translate}}</a>&nbsp;&nbsp;
                <a target="_blank" rel="noopener noreferrer" [href]="termsLink">{{'generic_terms_and_conditions' |
                    translate}}</a>
            </div>
            <div class="col-md-12" style="padding: 0 0 16px 0; text-align: center;">
                <a target="_blank" rel="noopener noreferrer" href="https://intercom.help/transportoperations/en/articles/11727860-release-notes-history" 
                   style="display: inline-block; padding: 8px 16px; background-color: #f0f0f0; border-radius: 4px; text-decoration: none; color: #333; font-weight: 500; margin-top: 8px;">
                    {{'generic_release_notes' | translate}}
                </a>
            </div>
        </div>
    </div>
    <button mat-icon-button class="close-button" (click)="discard()">
        <mat-icon>close</mat-icon>
    </button>
</div>
